import { gql } from "@apollo/client";

export const GET_AJUST_IN_PAGINATION = gql`
  query GetAdjustInPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $date: Date
    $supplierId: ID
    $warehouseId: ID
  ) {
    getAdjustInPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      date: $date
      supplierId: $supplierId
      warehouseId: $warehouseId
    ) {
      data {
        _id
        supplierId {
          name
          _id
        }
        remark
        createdAt
        dateTime
        reason
        createdBy {
          _id
          mainUserId {
            _id
            email
            firstName
            lastName
            latinName
            imageSrc
          }
          role
        }
        listAdjInMaterial {
          _id
          listMaterialUnitId {
            _id
            qtyInUnit
            barcode
            imageSrc
            unitId { 
              unitEnName
              unitKhName
            }
            materialId {
              _id
              materialEnName
              materialKhName 
            }
          }
          unitPrice
          qty
        }
        warehouseId {
          _id
          warehouseName
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;


export const UPDATE_ADJUST_IN = gql`
  mutation UpdateAdjustIn($id: ID!, $input: AdjustInInput) {
    updateAdjustIn(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CREATE_ADJUST_IN = gql`
  mutation CreateAdjustIn($input: AdjustInInput) {
    createAdjustIn(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;


export const UPDATE_ADJUST_OUT = gql`
  mutation UpdateAdjustOut($id: ID!, $input: AdjustOutInput) {
    updateAdjustOut(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`

export const CREATE_ADJUST_OUT = gql`
  mutation CreateAdjustOut($input: AdjustOutInput) {
    createAdjustOut(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const GET_ADJ_OUT_PAGINATOR = gql`
  query GetAdjustOutPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $date: Date
    $warehouseId: ID
  ) {
    getAdjustOutPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      date: $date
      warehouseId: $warehouseId
    ) {
      data {
        _id
        remark
        reason
        warehouseId {
          _id
          warehouseName
        }
        adjustOutMaterial {
          _id
          qty
          listMaterialUnitId {
            _id
            imageSrc
            materialId {
              _id
              materialKhName
              materialEnName
              remark
            }
            qtyInUnit
            remark
            unitId {
              _id
              isUse
              remark
              unitEnName
              unitKhName
            }
          }
        }
        createdBy {
          _id
          mainUserId {
            _id
            email
            firstName
            lastName
            latinName
            imageSrc
          }
          role
        }
        createdAt
        dateTime
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
